import { render, staticRenderFns } from "./MultasModal.vue?vue&type=template&id=1984eec7&"
import script from "./MultasModal.vue?vue&type=script&lang=js&"
export * from "./MultasModal.vue?vue&type=script&lang=js&"
import style0 from "./MultasModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports